import { configureStore } from '@reduxjs/toolkit';
import customer from './slices/customer';
import product from './slices/product';
import payment from './slices/payment';
import popup from './slices/popup';
import token from './slices/token';

export default configureStore({
  reducer: {
    'customer': customer,
    'popup': popup,
    'product': product,
    'payment': payment,
    'token': token
  },
});